export const stylesConsentBannerHeaderTitle = {
  color: 'grey.900',
  fontWeight: 600,
  fontSize: 16,
};

export const stylesConsentBannerActions = {
  display: 'flex',
  justifyContent: 'flex-end',
};

export const stylesConsentBannerContainer = {
  m: '0 1.5rem',
  bgcolor: 'background.paper',
  borderRadius: '5px',
  boxShadow: 1,
  p: 1,
};
